import {IoCaretDownSharp, IoCaretUpSharp} from "react-icons/io5";

function SortArrow({order, onChangeOrder}) {
  const upClass = order === 1 || order === 'asc' ? "text-tenken-gray-900" : "text-gray-400";
  const downClass = order === -1 || order === 'desc' ? "text-tenken-gray-900" : "text-gray-400";
  return (
    <div onClick={onChangeOrder} className="pt-[2px] cursor-pointer">
      <div>
      <IoCaretUpSharp className={upClass} size={12}/>
      </div>
      <div className="-mt-[4px]">
      <IoCaretDownSharp className={downClass} size={12}/>
      </div>
    </div>
  )
}

export default SortArrow;